import React from 'react';

type Props = {
  children: React.ReactNode;
  ignoreBottomPadding?: boolean;
};

export const HeaderArea = ({
  children,
  ignoreBottomPadding = false,
}: Props) => {
  return (
    <div
      className={`lg:pt-18 relative flex w-full flex-col items-center justify-center gap-6 bg-primary-dark p-6 pt-12 sm:pt-14 md:gap-10 md:pt-16 lg:gap-12 ${ignoreBottomPadding ? 'pb-0' : 'sm:pb-18 pb-16 md:pb-20 lg:pb-24'}`}
    >
      {children}
    </div>
  );
};
